import sv from '@/translations/sv-dahl.json';

export default defineI18nLocale(() => {
  if (process.env.NODE_ENV === 'test') return sv;
  return $fetch('/api/i18n-config');
});
